import NavbarNotAuth from '../userNotAuth/components/navbarNotAuth'
import DivBottom from '../userNotAuth/components/divBottom'
import NavbarTopAdmin from '../admin/components/navbarTopAdmin'
import NavbarBottomAdmin from '../admin/components/navbarBottomAdmin'
import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'

function AddFoodTruckSuccess() {
    const redux = useSelector((state) => state.creaArtista.value)
    const [tipoCucinaArr, setTipoCucinaArr] = useState([])

    const grid = { display: 'grid', gridTemplateColumns: '6rem 70% ', gap: '5px' }

    useEffect(() => {
        // console.log('redux:', redux)

        if (redux.tipoCucina.length !== 0) {
            let vbn = []//array di appoggio per state tipoCucinaArr
            redux.tipoCucina.forEach((elem, index) => {
                switch (elem) {
                    case "italiana": vbn.push('Cucina italiana tradizionale'); break
                    case "hamburger": vbn.push('Hamburger & Fast Food'); break
                    case "etnica": vbn.push('Etnica/Internazionale'); break
                    case "vegetariana": vbn.push('Vegetariana'); break
                    case "vegana": vbn.push('Vegana'); break
                    case "dolci": vbn.push('Dolci & Gelati'); break
                    case "bar": vbn.push('Bar/Cocktail/Birre/Frullati/Centrifugati'); break
                    case "griglia": vbn.push('Griglia & Barbecue'); break
                    default:
                }
            })
            setTipoCucinaArr(vbn)
        }
    }, [redux])
    useEffect(() => { window.scrollTo(0, 0) }, [])
    return (<>
        {localStorage.getItem('email') === 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />}
        <div className='container' style={{ marginBottom: '1rem', marginTop: '6rem' }}>
            <h4>PROFILO FOOD TRUCK CREATO CON SUCCESSO!</h4>
            <p className='fs-6 mt-5'>
                Il tuo profilo di Food Truck è stato creato ma prima di essere pubblicato dovrà essere approvato
                dal nostro staff.
            </p>
            <p>Ti invieremo un'email qunado il tuo profilo sarà inserito nella vetrina del nostro sito.
            </p>
            <hr />
            <div style={grid}>
                <div>Nome: </div> <div><b>{redux.nome}</b></div>
            </div>
            <div style={grid}>
                <div>Regione: </div> <div><b>{redux.regione}</b></div>
                <div>Città: </div> <div><b>{redux.città}</b></div>
                <div>Descrizione: </div> <div><i>{redux.descrizione}</i></div>
                <div>Specialità: </div><div>{redux.specialità}</div>
            </div>

            {redux.tipoCucina &&
                <div style={grid} className='mt-3'>
                    <div>Tipologia:</div>
                    <div>
                        {tipoCucinaArr.map((elem, index) => (
                            <span key={index}>{elem}{index < redux.tipoCucina.length - 1 && <span>, </span>}
                            </span>
                        ))
                        }
                    </div>
                </div>
            }

            <br />
            {redux.telefono !== '' &&
                <div style={grid}>
                    <div>Telefono: </div> <div>{redux.telefono}</div>
                </div>
            }
            {redux.url !== '' &&
                <div style={grid}>
                    <div>URL sito web: </div> <div>{redux.url.substring(0, 30)}...</div>
                </div>
            }
            {redux.fb !== '' &&
                <div style={grid}>
                    <div>URL FB: </div> <div>{redux.fb.substring(0, 30)}...</div>
                </div>
            }
            {redux.youtube !== '' &&
                <div style={grid}>
                    <div>URL YouTube: </div> <div>{redux.youtube.substring(0, 30)}...</div>
                </div>
            }

            <div style={grid}>
                <div>Email: </div> <div>{redux.email}</div>
            </div><hr />

            {redux.foto.length !== 0 &&
                <div className='mt-5'>
                    <h6>IMMAGINI CARICATE</h6>
                    <div className='mt-3' style={{ display: 'flex' }}>
                        {redux.foto.map((elem, index) => (
                            <div key={index}>
                                <img src={`https://leuro-bucket.s3.amazonaws.com/${elem}`} style={{ maxWidth: '114px', margin: '3px' }} />
                            </div>
                        ))}
                    </div>
                </div>
            }
            {redux.video &&
                <div className='mt-4'>
                    <h6>VIDEO CARICATO</h6>
                    <video src={`https://leuro-bucket.s3.amazonaws.com/video/${redux.video}`} id={'videoPreview'} style={{ width: '144px', borderRadius: '5px' }} controls />
                </div>
            }
        </div>
        <DivBottom />
    </>)
}
export default AddFoodTruckSuccess
